module.exports = __webpack_public_path__ + "img/city.a25b65e0.svg";